import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Navbar from './components/navbar.jsx';
import PrivateRoute from './components/privateroute.jsx';
import Home from './components/home.jsx';
import TakipListem from './components/takip-listem.jsx';
import AlimSatim from './components/alim-satim.jsx';
import Hesabim from './components/hesabim.jsx';
import HisseDetay from './components/hisse-detay.jsx';
import Login from './components/login.jsx';
import Register from './components/register.jsx';
import Logout from './components/logout.jsx';

function UygulamaSayfalari() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans text-slate-900 selection:bg-sky-200 selection:text-sky-900">
      <Navbar />
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Switch>
          <PrivateRoute path="/takip-listem" component={TakipListem} />
          <PrivateRoute path="/alim-satim" component={AlimSatim} />
          <PrivateRoute path="/hesabim" component={Hesabim} />
          <Route path="/hisse/:kod" component={HisseDetay} />
          <Route path="/login" component={Login} />
          <Route path="/register" component={Register} />
          <Route path="/logout" component={Logout} />
        </Switch>
      </main>
      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-center text-xs text-slate-400">
          BIST Hisse Takip
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route component={UygulamaSayfalari} />
      </Switch>
    </Router>
  );
}

export default App
